import CarPageAiBanner from './car-page-ai-banner';

function init() {
  CarPageAiBanner.init();
}

export { init };
